import { useState, useEffect } from 'react';
import { apiClient } from '@/lib/api/client';

interface TopBuyer {
  nickname: string;
  totalSpent: number;
  totalPurchases: number;
}

export function useTopBuyer(storeId: string | undefined) {
  const [topBuyer, setTopBuyer] = useState<TopBuyer | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    if (!storeId) {
      setLoading(false);
      return;
    }

    const fetchTopBuyer = async () => {
      try {
        setLoading(true);
        const response = await apiClient.get<{ topBuyer: TopBuyer | null }>(`/public/stores/${storeId}/top-buyer`);
        setTopBuyer(response.topBuyer);
      } catch {
        setError('error');
      } finally {
        setLoading(false);
      }
    };

    fetchTopBuyer();
  }, [storeId]);

  return { topBuyer, loading, error };
}
